import React from 'react';

import { LinkButton } from 'com-gyf-webcore-userinterfacecomponents';

import PanelPermisos from './PanelPermisos';

const ContenedorPermisos = (props) => {
    let permisosNodes = props.permisos.map(function (permiso) {
        return (
            <PanelPermisos permisos={props.permisos}
                permiso={permiso}
                errorMessageFunciones={props.errorMessageFunciones}
                deletePermiso={props.deletePermiso}
                selectProducto={props.selectProducto}
                selectCategoria={props.selectCategoria}
                selectPrograma={props.selectPrograma}
                selectTodasFunciones={props.selectTodasFunciones}
                unselectTodasFunciones={props.unselectTodasFunciones}
                checkFuncion={props.checkFuncion} />
        );
    });

    return (
        <div className="row bottom-separator-xs">
            <div className="col-xs-12">
                {permisosNodes}
                <LinkButton text="Agregar otro bloque de permisos" onClick={() => props.addPermiso()} />
            </div>
        </div>
    );
}

export default ContenedorPermisos;